<template>
  <div class="score">
    <span class="rank star" v-if="Number(rankNum)">x{{ rankNum }}</span>
    <span class="rank thumb">{{ thumb }}</span>
  </div>
</template>
<script>
export default {
  name: 'Score',
  props: ['rankNum', 'thumb']
}
</script>
<style lang="less" scoped>
.score {
  .rank {
    padding: 0 6px;
    font-size: 11px;
    color: rgba(190, 130, 67, 1);
    background: rgba(190, 130, 67, 0.06);
    border-radius: 2px;
  }

  .rank::before {
    display: inline-block;
    margin: 0 2px;
    background-size: 100% 100%;
    content: '';
  }

  .star::before {
    width: 14px;
    height: 14px;
    vertical-align: -3px;
    background-image: url('../assets/apply/star_icon.png');
  }

  .thumb {
    margin-left: 4px;
  }

  .thumb::before {
    width: 12px;
    height: 10px;
    background-image: url('../assets/apply/crown_icon.png');
  }
}
</style>
